{
    "sources": {
        "festatic": {
            "type": "vector",
            "tiles": ["https://dhpfl5h9i14m7.cloudfront.net/FEStatic-AAABC-YYYYMMDD-YYYYMMDDHHMMSS/{z}/{x}/{y}.mvt"],
            "minzoom": 0,
            "maxzoom": 12,
            "attribution": "CAE FE"
        }
    },
    "layers": [
        {
            "id": "overwater",
            "type": "line",
            "source": "festatic",
            "source-layer": "overwater",
            "minzoom": 0,
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "line-color": ["global-state", "feNav_line-color_overwater"],
                "line-width": 1,
                "line-opacity": 0.3
            }
        },
        {
            "id": "deicing",
            "type": "line",
            "source": "festatic",
            "source-layer": "deicing",
            "minzoom": 11,
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "line-color": "blue",
                "line-width": 2,
                "line-opacity": 0.3
            }
        },
        {
            "id": "runway",
            "type": "fill",
            "source": "festatic",
            "source-layer": "runway_poly",
            "minzoom": 9,
            "layout": {
                "visibility": "visible"
            },
            "paint": {
                "fill-color": "grey",
                "fill-opacity": 0.7
            }
        },
        {
            "id": "runway-center-arrow-left",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "runway",
            "minzoom": 12,
            "layout": {
                "visibility": "visible",
                "symbol-spacing": 42,
                "icon-image": "fe:arrow-left",
                "icon-size": 0.5,
                "icon-rotation-alignment": "map",
                "icon-pitch-alignment": "viewport",
                "symbol-placement": "line"
            },
            "paint": {
                "icon-color": "#ffffff"
            }
        },
        {
            "id": "runway-center-arrow-right",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "runway",
            "minzoom": 12,
            "layout": {
                "visibility": "visible",
                "symbol-spacing": 42,
                "icon-image": "fe:arrow-right",
                "icon-size": 0.5,
                "icon-rotation-alignment": "map",
                "icon-pitch-alignment": "viewport",
                "symbol-placement": "line"
            },
            "paint": {
                "icon-color": "#ffffff"
            }
        },
        {
            "id": "gridmora1",
            "type": "line",
            "source": "festatic",
            "source-layer": "gridmora1",
            "minzoom": 4,
            "maxzoom": 24,
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "line-width": 2,
                "line-opacity": 0.05,
                "line-color": ["global-state", "feNav_line-color_mor"]
            }
        },
        {
            "id": "gridmora1_label",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "gridmora1",
            "minzoom": 4,
            "maxzoom": 24,
            "layout": {
                "visibility": "none",
                "symbol-placement": "point",
                "text-field": ["to-string", ["round", ["/", ["get", "mora"], 1000]]],
                "text-size": {
                    "stops": [
                        [4, 8],
                        [8, 18]
                    ]
                },
                "text-justify": "center",
                "text-font": ["Metropolis Bold"],
                "text-allow-overlap": true,
                "text-anchor": "right",
                "text-offset": [0.1, 0.4]
            },
            "paint": {
                "text-halo-blur": 0,
                "icon-halo-width": 0,
                "text-opacity": 0.3,
                "text-color": [
                    "case",
                    ["==", ["get", "mora"], 999],
                    "rgba(0,0,0,0)",
                    [">=", ["get", "mora"], 10000],
                    "rgba(255,0,255, 1)",
                    ["global-state", "feNav_text-color_mor_def"]
                ]
            }
        },
        {
            "id": "gridmora1_label2",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "gridmora1",
            "minzoom": 4,
            "maxzoom": 24,
            "layout": {
                "visibility": "none",
                "symbol-placement": "point",
                "text-field": ["to-string", ["round", ["/", ["%", ["get", "mora"], 1000], 100]]],
                "text-size": {
                    "stops": [
                        [4, 6],
                        [8, 12]
                    ]
                },
                "text-justify": "center",
                "text-font": ["Metropolis Bold"],
                "text-allow-overlap": true,
                "text-anchor": "left",
                "text-offset": [0.4, 0.3]
            },
            "paint": {
                "text-color": [
                    "case",
                    ["==", ["get", "mora"], 999],
                    "rgba(0,0,0,0)",
                    [">=", ["get", "mora"], 10000],
                    "rgba(255,0,255, 1)",
                    ["global-state", "feNav_text-color_mor_def"]
                ],
                "text-halo-blur": 0,
                "icon-halo-width": 0,
                "text-opacity": 0.3
            }
        },
        {
            "id": "gridmora5",
            "type": "line",
            "source": "festatic",
            "source-layer": "gridmora5",
            "minzoom": 0,
            "maxzoom": 4,
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "line-width": 2,
                "line-opacity": {
                    "stops": [
                        [0, 0.001],
                        [3, 0.05]
                    ]
                },
                "line-color": ["global-state", "feNav_line-color_mor"]
            }
        },
        {
            "id": "gridmora5_label",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "gridmora5",
            "minzoom": 2,
            "maxzoom": 4,
            "layout": {
                "visibility": "none",
                "symbol-placement": "point",
                "text-field": ["to-string", ["round", ["/", ["get", "mora"], 1000]]],
                "text-size": {
                    "stops": [
                        [0, 2],
                        [4, 18]
                    ]
                },
                "text-justify": "center",
                "text-font": ["Metropolis Bold"],
                "text-allow-overlap": true,
                "text-anchor": "right",
                "text-offset": [0.1, 0.4]
            },
            "paint": {
                "text-color": [
                    "case",
                    ["==", ["get", "mora"], 999],
                    "rgba(0,0,0,0)",
                    [">=", ["get", "mora"], 10000],
                    "rgba(255,0,255, 1)",
                    ["global-state", "feNav_text-color_mor_def"]
                ],
                "text-halo-blur": 0,
                "icon-halo-width": 0,
                "text-opacity": 0.3
            }
        },
        {
            "id": "gridmora5_label2",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "gridmora5",
            "minzoom": 2,
            "maxzoom": 4,
            "layout": {
                "visibility": "none",
                "symbol-placement": "point",
                "text-field": ["to-string", ["round", ["/", ["%", ["get", "mora"], 1000], 100]]],
                "text-size": {
                    "stops": [
                        [0, 1],
                        [4, 12]
                    ]
                },
                "text-justify": "center",
                "text-font": ["Metropolis Bold"],
                "text-allow-overlap": true,
                "text-anchor": "left",
                "text-offset": [0.4, 0.3]
            },
            "paint": {
                "text-color": [
                    "case",
                    ["==", ["get", "mora"], 999],
                    "rgba(0,0,0,0)",
                    [">=", ["get", "mora"], 10000],
                    "rgba(255,0,255, 1)",
                    ["global-state", "feNav_text-color_mor_def"]
                ],
                "text-halo-blur": 0,
                "icon-halo-width": 0,
                "text-opacity": 0.3
            }
        },
        {
            "id": "timezone",
            "type": "line",
            "source": "festatic",
            "source-layer": "timezone",
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "line-opacity": 0.2,
                "line-width": 1,
                "line-color": "RGBA(100, 100, 100, 0.6)"
            }
        },
        {
            "id": "airspace_border",
            "type": "line",
            "source": "festatic",
            "source-layer": "airspace",
            "minzoom": 0,
            "filter": ["match", ["get", "class"], ["C", "D"], false, true],
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "line-color": [
                    "match",
                    ["get", "class"],
                    ["B", "C", "D"],
                    "rgb(0, 75, 148)",
                    ["A", "E", "F", "G", "T", "U", "V"],
                    "rgb(157, 92, 156)",
                    "rgb(157, 92, 156)"
                ],
                "line-width": {
                    "stops": [
                        [0, 0.2],
                        [10, 1]
                    ]
                },
                "line-opacity": {
                    "stops": [
                        [0, 0],
                        [6, 1]
                    ]
                }
            }
        },
        {
            "id": "airspace_border2",
            "type": "line",
            "source": "festatic",
            "source-layer": "airspace",
            "minzoom": 0,
            "filter": ["match", ["get", "class"], ["C", "D"], true, false],
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "line-color": [
                    "match",
                    ["get", "class"],
                    ["B", "C", "D"],
                    "rgb(0, 75, 148)",
                    ["A", "E", "F", "G", "T", "U", "V"],
                    "rgb(157, 92, 156)",
                    "rgb(157, 92, 156)"
                ],
                "line-dasharray": [4, 2],
                "line-width": {
                    "stops": [
                        [0, 0.2],
                        [10, 1]
                    ]
                },
                "line-opacity": {
                    "stops": [
                        [0, 0],
                        [6, 1]
                    ]
                }
            }
        },
        {
            "id": "airspace_fill",
            "type": "fill",
            "source": "festatic",
            "source-layer": "airspace",
            "minzoom": 1,
            "filter": ["all", ["match", ["get", "class"], ["B", "C"], true, false]],
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "fill-color": [
                    "match",
                    ["get", "class"],
                    ["B", "C", "D"],
                    "rgb(0, 75, 148)",
                    ["A", "E", "F", "G", "T", "U", "V"],
                    "rgb(157, 92, 156)",
                    "rgba(0, 0, 0, 0)"
                ],
                "fill-opacity": {
                    "stops": [
                        [0, 0],
                        [6, 0.05]
                    ]
                }
            }
        },
        {
            "id": "airspace_label",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "airspace",
            "minzoom": 8,
            "filter": ["match", ["get", "class"], ["T", "U", "V"], false, true],
            "layout": {
                "visibility": "none",
                "symbol-placement": "line",
                "text-field": [
                    "format",
                    ["get", "id"],
                    " - ",
                    ["get", "name"],
                    " (",
                    ["get", "ualt"],
                    "/",
                    ["get", "lalt"],
                    ") ",
                    ["get", "class"]
                ],
                "symbol-spacing": 300,
                "text-optional": true,
                "text-size": 9,
                "text-allow-overlap": false,
                "text-ignore-placement": false,
                "symbol-avoid-edges": true,
                "text-anchor": "center",
                "text-justify": "center",
                "text-font": ["Metropolis Regular"],
                "text-offset": [0, 0.6]
            },
            "paint": {
                "text-halo-width": 20,
                "text-halo-color": [
                    "match",
                    ["get", "class"],
                    ["B", "C", "D"],
                    "rgba(0, 75, 148, 0.15)",
                    ["A", "E", "F", "G", "T", "U", "V"],
                    "rgba(157, 92, 156, 0.15)",
                    "rgba(157, 92, 156, 0.15)"
                ],
                "text-color": ["global-state", "feNav_text-color_aspl"],
                "text-halo-blur": 0,
                "icon-halo-width": 0
            }
        },
        {
            "id": "airspace_label2",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "airspace",
            "minzoom": 3,
            "filter": ["match", ["get", "class"], ["T", "U", "V"], true, false],
            "layout": {
                "visibility": "none",
                "symbol-placement": "line",
                "text-field": [
                    "step",
                    ["zoom"],
                    ["format", ["get", "id"]],
                    5,
                    [
                        "format",
                        ["get", "id"],
                        " - ",
                        ["get", "name"],
                        " (",
                        ["get", "ualt"],
                        "/",
                        ["get", "lalt"],
                        ") ",
                        [
                          "match",
                          [ "get", "class" ],
                          "T", "FIR",
                          "U", "UIR",
                          "V", "FIR/UIR",
                          ["get", "class"]
                        ]
                    ]
                ],
                "symbol-spacing": 300,
                "text-optional": true,
                "text-size": 10,
                "text-allow-overlap": false,
                "text-ignore-placement": false,
                "symbol-avoid-edges": true,
                "text-anchor": "center",
                "text-justify": "center",
                "text-font": ["Metropolis Regular"],
                "text-offset": [0, 0.6]
            },
            "paint": {
                "text-halo-width": 20,
                "text-halo-color": [
                    "match",
                    ["get", "class"],
                    ["B", "C", "D"],
                    "rgba(0, 75, 148, 0.15)",
                    ["A", "E", "F", "G", "T", "U", "V"],
                    "rgba(157, 92, 156, 0.15)",
                    "rgba(157, 92, 156, 0.15)"
                ],
                "text-color": ["global-state", "feNav_text-color_aspl"],
                "text-halo-blur": 0,
                "icon-halo-width": 0
            }
        },
        {
            "id": "sua_fill",
            "type": "fill",
            "source": "festatic",
            "source-layer": "sua",
            "minzoom": 0,
            "maxzoom": 24,
            "layout": {
                "visibility": "none"
            },
            "paint": {
                "fill-color": [
                    "match",
                    ["get", "type"],
                    ["P", "R", "W"],
                    "rgb(133, 151, 197)",
                    ["A", "M"],
                    "rgb(184, 161, 137)",
                    "rgb(184, 161, 137)"
                ],
                "fill-opacity": 0.15
            }
        },
        {
            "id": "sua_band",
            "type": "line",
            "source": "festatic",
            "source-layer": "sua",
            "minzoom": 3,
            "maxzoom": 24,
            "layout": {
                "visibility": "none",
                "line-cap": "butt",
                "line-join": "miter"
            },
            "paint": {
                "line-color": [
                    "match",
                    ["get", "type"],
                    ["P", "R", "W"],
                    "rgb(133, 151, 197)",
                    ["A", "M"],
                    "rgb(184, 161, 137)",
                    "rgb(184, 161, 137)"
                ],
                "line-width": {
                    "stops": [
                        [0, 0],
                        [4, 2],
                        [10, 6]
                    ]
                },
                "line-offset": {
                    "stops": [
                        [0, 0],
                        [4, 1],
                        [10, 3]
                    ]
                },
                "line-opacity": {
                    "stops": [
                        [0, 0],
                        [3, 0.2],
                        [4, 0.2]
                    ]
                }
            }
        },
        {
            "id": "sua_border",
            "type": "line",
            "source": "festatic",
            "source-layer": "sua",
            "minzoom": 0,
            "maxzoom": 24,
            "filter": ["all"],
            "layout": {
                "visibility": "none",
                "line-join": "miter",
                "line-cap": "butt"
            },
            "paint": {
                "line-color": [
                    "match",
                    ["get", "type"],
                    ["P", "R", "W"],
                    "rgb(133, 151, 197)",
                    ["A", "M"],
                    "rgb(184, 161, 137)",
                    "rgb(184, 161, 137)"
                ],
                "line-width": {
                    "stops": [
                        [0, 0.1],
                        [10, 2]
                    ]
                },
                "line-opacity": {
                    "stops": [
                        [0, 0.5],
                        [4, 1]
                    ]
                }
            }
        },
        {
            "id": "sua_label",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "sua",
            "minzoom": 8,
            "filter": ["all", ["match", ["get", "type"], ["P", "R", "W", "A", "M"], true, false]],
            "layout": {
                "visibility": "none",
                "symbol-placement": "line",
                "text-field": ["format", ["get", "id"], " - ", ["get", "name"], "  ", ["get", "lalt"], "-", ["get", "ualt"]],
                "symbol-spacing": 400,
                "text-optional": true,
                "text-size": 10,
                "text-allow-overlap": false,
                "text-ignore-placement": false,
                "symbol-avoid-edges": true,
                "text-anchor": "center",
                "text-justify": "center",
                "text-font": ["Metropolis Regular"],
                "text-transform": "none",
                "text-offset": [0, 1.3]
            },
            "paint": {
                "text-halo-width": 20,
                "text-halo-color": [
                    "match",
                    ["get", "type"],
                    ["P", "R", "W"],
                    "rgba(133, 151, 197,0.15)",
                    ["A", "M"],
                    "rgba(184, 161, 137, 0.15)",
                    "rgba(184, 161, 137, 0.15)"
                ],
                "text-color": ["global-state", "feNav_text-color_sual"],
                "text-halo-blur": 0,
                "icon-halo-width": 0
            }
        },
        {
            "id": "holding",
            "type": "line",
            "source": "festatic",
            "source-layer": "holding",
            "minzoom": 4,
            "maxzoom": 24,
            "layout": { "visibility": "none" },
            "paint": {
                "line-color": "rgba(102, 153, 255, 0.8)",
                "line-width": {
                    "stops": [
                        [0, 0.1],
                        [10, 1]
                    ]
                },
                "line-opacity": {
                    "stops": [
                        [0, 0.5],
                        [4, 1]
                    ]
                }
            }
        },
        {
            "id": "holding_label",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "holding",
            "minzoom": 10,
            "layout": {
                "visibility": "none",
                "symbol-placement": "line",
                "text-field": ["get", "fixid"],
                "symbol-spacing": 400,
                "text-optional": true,
                "text-size": 9,
                "text-allow-overlap": false,
                "text-ignore-placement": false,
                "symbol-avoid-edges": true,
                "text-anchor": "center",
                "text-offset": [0, 0.8],
                "text-justify": "center",
                "text-font": ["Metropolis Regular"]
            },
            "paint": {
                "text-halo-width": 20,
                "text-halo-color": "rgb(102,153,255,0.15)",
                "text-color": ["global-state", "feNav_text-color_hldl"],
                "text-halo-blur": 0,
                "icon-halo-width": 0
            }
        },
        {
            "id": "airport",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "airport",
            "minzoom": 3,
            "filter": ["all", ["match", ["get", "apttype"], ["A"], true, false], ["==", ["get", "ct"], true]],
            "layout": {
                "visibility": "none",
                "icon-image": [
                    "match",
                    ["get", "apttype"],
                    ["A"],
                    ["match", ["get", "pubmil"], ["C"], "fe:airport-civil", ["M"], "fe:airport-military", "fe:airport-military-civil"],
                    ["H"],
                    "fe:airport-heliport",
                    ["S"],
                    "fe:airport-seaplane",
                    "fe:airport-other"
                ],
                "icon-size": 0.5,
                "text-allow-overlap": true,
                "icon-allow-overlap": true,
                "text-field": ["get", "iataid"],
                "text-font": ["Metropolis Regular"],
                "text-size": 10,
                "text-anchor": "top",
                "text-offset": [0, 0]
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "text-color": ["global-state", "feNav_text-color"],
                "icon-opacity": {
                    "stops": [
                        [3, 0.1],
                        [4, 0.5],
                        [5, 1]
                    ]
                },
                "text-opacity": {
                    "stops": [
                        [3, 0],
                        [4, 0],
                        [5, 0.9]
                    ]
                }
            }
        },
        {
            "id": "navaid",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "navaid",
            "minzoom": 3,
            "layout": {
                "icon-image": [
                    "match",
                    ["get", "type"],
                    3,
                    "fe:navaid-ndb",
                    4,
                    "fe:navaid-vor",
                    5,
                    "fe:navaid-vordme",
                    6,
                    "fe:navaid-vortac",
                    7,
                    "fe:navaid-tacan",
                    11,
                    "fe:navaid-ndbdme",
                    14,
                    "fe:navaid-dme",
                    "fe:navaid-vor"
                ],
                "icon-size": 0.5,
                "icon-allow-overlap": true,
                "visibility": "none",
                "icon-ignore-placement": false,
                "text-field": "{id}",
                "text-allow-overlap": true,
                "text-size": 9,
                "text-anchor": "top",
                "text-font": ["Metropolis Regular"],
                "text-ignore-placement": true
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "text-color": ["global-state", "feNav_text-color"],
                "icon-opacity": {
                    "stops": [
                        [3, 0.05],
                        [5, 0.4],
                        [9, 0.8]
                    ]
                },
                "text-opacity": {
                    "stops": [
                        [3, 0],
                        [7, 0],
                        [9, 0.7]
                    ]
                }
            }
        },
        {
            "id": "navaid_rose",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "navaid",
            "minzoom": 6,
            "filter": ["all", ["match", ["get", "type"], [4, 5, 6], true, false]],
            "layout": {
                "visibility": "none",
                "icon-image": "fe:compass-rose",
                "icon-allow-overlap": false,
                "icon-rotate": { "type": "identity", "property": "magvar" },
                "icon-rotation-alignment": "map",
                "icon-pitch-alignment": "map",
                "text-allow-overlap": true,
                "text-ignore-placement": true,
                "icon-ignore-placement": false,
                "icon-optional": false,
                "icon-size": 0.5
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "icon-opacity": {
                    "stops": [
                        [6, 0],
                        [10, 0.4]
                    ]
                }
            }
        },
        {
            "id": "fix",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "fix",
            "minzoom": 2,
            "layout": {
                "icon-image": ["match", ["get", "type"], "R", "fe:star-hollow", "fe:triangle-hollow"],
                "visibility": "none",
                "text-ignore-placement": true,
                "text-allow-overlap": true,
                "icon-allow-overlap": true,
                "icon-size": ["match", ["get", "type"], "R", 0.5, 0.3],
                "text-field": "{id}",
                "text-size": 9,
                "text-font": ["Metropolis Regular"],
                "text-anchor": "top",
                "symbol-spacing": 250,
                "icon-ignore-placement": true,
                "icon-optional": false
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "text-color": ["global-state", "feNav_text-color"],
                "icon-opacity": {
                    "stops": [
                        [2, 0.2],
                        [4, 0.3],
                        [8, 0.9]
                    ]
                },
                "text-opacity": {
                    "stops": [
                        [3, 0],
                        [5, 0],
                        [8, 0.8]
                    ]
                }
            }
        },
        {
            "id": "fix_t",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "fix_t",
            "minzoom": 8,
            "layout": {
                "icon-image": "fe:triangle-hollow",
                "visibility": "none",
                "text-ignore-placement": true,
                "text-allow-overlap": true,
                "icon-allow-overlap": true,
                "icon-size": 0.3,
                "text-field": "{id}",
                "text-size": 9,
                "text-font": ["Metropolis Regular"],
                "text-offset": [0, 1.5],
                "icon-ignore-placement": true
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "text-color": ["global-state", "feNav_text-color"],
                "icon-opacity": {
                    "stops": [
                        [2, 0.2],
                        [4, 0.3],
                        [8, 0.9]
                    ]
                },
                "text-opacity": {
                    "stops": [
                        [3, 0],
                        [5, 0],
                        [8, 0.8]
                    ]
                }
            }
        },
        {
            "id": "star",
            "type": "line",
            "source": "festatic",
            "source-layer": "star",
            "minzoom": 4,
            "layout": { "visibility": "none" },
            "paint": {
                "line-color": ["global-state", "feNav_line-color"],
                "line-width": 1,
                "line-opacity": 0.8
            }
        },
        {
            "id": "star_arrow",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "star",
            "minzoom": 4,
            "layout": {
                "visibility": "none",
                "icon-image": "fe:arrow-right",
                "symbol-placement": "line",
                "icon-size": 0.6,
                "symbol-spacing": 200,
                "icon-allow-overlap": false,
                "icon-ignore-placement": false,
                "text-field": ["get", "id"],
                "text-size": 9,
                "text-allow-overlap": false,
                "symbol-avoid-edges": true,
                "text-anchor": "center",
                "text-justify": "center",
                "text-font": ["Metropolis Regular"],
                "text-offset": [7, 0.7],
                "icon-anchor": "center"
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "text-color": ["global-state", "feNav_text-color"]
            }
        },
        {
            "id": "star_point",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "star_point",
            "minzoom": 7,
            "layout": {
                "icon-image": "fe:triangle-hollow",
                "visibility": "none",
                "icon-size": 0.3,
                "text-field": ["get", "pointid"],
                "text-size": 9,
                "text-justify": "left",
                "text-font": ["Metropolis Regular"],
                "text-allow-overlap": true,
                "text-anchor": "left",
                "text-offset": [0.4, 1.4],
                "text-ignore-placement": true
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "text-color": ["global-state", "feNav_text-color"]
            }
        },
        {
            "id": "sid",
            "type": "line",
            "source": "festatic",
            "source-layer": "sid",
            "minzoom": 4,
            "layout": { "visibility": "none" },
            "paint": {
                "line-width": 1,
                "line-opacity": 0.8,
                "line-color": ["global-state", "feNav_line-color"]
            }
        },
        {
            "id": "sid_arrow",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "sid",
            "minzoom": 4,
            "layout": {
                "visibility": "none",
                "icon-image": "fe:arrow-right",
                "symbol-placement": "line",
                "icon-size": 0.6,
                "symbol-spacing": 200,
                "icon-allow-overlap": false,
                "icon-ignore-placement": false,
                "text-field": ["get", "id"],
                "text-size": 9,
                "text-allow-overlap": false,
                "symbol-avoid-edges": true,
                "text-anchor": "center",
                "text-justify": "center",
                "text-font": ["Metropolis Regular"],
                "text-offset": [7, 0.7],
                "icon-anchor": "center"
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "text-color": ["global-state", "feNav_text-color"]
            }
        },
        {
            "id": "sid_point",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "sid_point",
            "minzoom": 7,
            "layout": {
                "icon-image": "fe:triangle-hollow",
                "visibility": "none",
                "icon-size": 0.3,
                "text-field": ["get", "pointid"],
                "text-size": 9,
                "text-justify": "left",
                "text-font": ["Metropolis Regular"],
                "text-allow-overlap": true,
                "text-anchor": "left",
                "text-offset": [0.4, 1.4],
                "text-ignore-placement": true
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "text-color": ["global-state", "feNav_text-color"]
            }
        },
        {
            "id": "fss",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "fss",
            "minzoom": 3,
            "layout": {
                "icon-image": "fe:fss",
                "visibility": "none",
                "text-field": "{name} ({id})",
                "text-size": 9,
                "text-justify": "center",
                "text-font": ["Metropolis Regular"],
                "text-allow-overlap": true,
                "text-anchor": "top",
                "text-offset": [0, 1.2],
                "text-ignore-placement": true,
                "icon-size": 0.5
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "text-color": ["global-state", "feNav_text-color"],
                "icon-opacity": {
                    "stops": [
                        [2, 0.2],
                        [4, 0.4],
                        [8, 1]
                    ]
                },
                "text-opacity": {
                    "stops": [
                        [3, 0],
                        [5, 0],
                        [8, 0.8]
                    ]
                }
            }
        },
        {
            "id": "wstation",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "wstation",
            "minzoom": 3,
            "layout": {
                "icon-image": "fe:wstation",
                "visibility": "none",
                "text-ignore-placement": true,
                "text-allow-overlap": true,
                "icon-size": 0.3,
                "text-field": ["get", "id"],
                "text-size": 9,
                "text-justify": "center",
                "text-font": ["Metropolis Regular"],
                "text-anchor": "center",
                "text-offset": [0, 1.6]
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "text-color": ["global-state", "feNav_text-color"],
                "icon-opacity": {
                    "stops": [
                        [2, 0.2],
                        [4, 0.4],
                        [8, 1]
                    ]
                },
                "text-opacity": {
                    "stops": [
                        [3, 0],
                        [5, 0],
                        [8, 0.8]
                    ]
                }
            }
        },
        {
            "id": "airway",
            "type": "line",
            "source": "festatic",
            "source-layer": "airway",
            "layout": { "visibility": "none" },
            "paint": {
                "line-color": [
                    "match",
                    ["slice", ["get", "id"], 0, 1],
                    ["T", "Q"],
                    "rgba(0, 0, 160, 1)",
                    ["global-state", "feNav_line-color_awy_def"]
                ],
                "line-width": {
                    "stops": [
                        [0, 1],
                        [8, 1],
                        [10, 3]
                    ]
                },
                "line-opacity": {
                    "stops": [
                        [0, 0.01],
                        [6, 0.6]
                    ]
                }
            }
        },
        {
            "id": "airway_label",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "airway",
            "minzoom": 5,
            "layout": {
                "visibility": "none",
                "symbol-placement": "line",
                "text-field": ["get", "id"],
                "text-size": 10,
                "text-allow-overlap": false,
                "symbol-avoid-edges": true,
                "text-anchor": "center",
                "text-justify": "center",
                "text-font": ["Metropolis Bold"],
                "icon-anchor": "center",
                "icon-rotation-alignment": "auto",
                "text-pitch-alignment": "auto",
                "text-ignore-placement": false,
                "text-rotation-alignment": "auto",
                "text-transform": "none",
                "text-optional": false,
                "icon-text-fit": "both",
                "icon-pitch-alignment": "auto",
                "icon-image": ["match", ["get", "dir"], "Fx", "fe:right-filled-arrow", "Bx", "fe:left-filled-arrow", "fe:rect-filled"],
                "icon-keep-upright": true,
                "icon-text-fit-padding": [3, 5, 3, 5],
                "icon-offset": [0, 0],
                "icon-size": 1
            },
            "paint": {
                "text-color": ["global-state", "feNav_text-color_awyl"],
                "icon-color": [
                    "match",
                    ["slice", ["get", "id"], 0, 1],
                    ["T", "Q"],
                    "rgba(0, 0, 160, 1)",
                    ["global-state", "feNav_icon-color_awy_def"]
                ]
            }
        },
        {
            "id": "airway_point",
            "type": "symbol",
            "source": "festatic",
            "source-layer": "airway_point",
            "minzoom": 6,
            "layout": {
                "icon-image": "fe:triangle-hollow",
                "visibility": "none",
                "icon-size": 0.3,
                "text-field": ["get", "pointid"],
                "text-size": 10,
                "text-justify": "left",
                "text-font": ["Metropolis Regular"],
                "text-allow-overlap": true,
                "text-anchor": "left",
                "text-ignore-placement": true
            },
            "paint": {
                "icon-color": ["global-state", "feNav_icon-color"],
                "text-color": ["global-state", "feNav_text-color"],
                "text-opacity": {
                    "stops": [
                        [3, 0],
                        [6, 0],
                        [8, 0.8]
                    ]
                }
            }
        }
    ]
}
